import React, { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';

type MonitorProps = {
  showingReference: string;
};

type UpdateGroupCountModel = {
  reference: string;
  count: number;
  browsers: AggregatedBrowserDetails[];
};

export type BrowserDetails = {
  browserName: string | null;
  osName: string | null;
  browserVersion: string | null;
  osVersion: string | null;
  deviceType: string | null;
  fullBrowserVersion: string | null;
};

export type AggregatedBrowserDetails = {
  details: BrowserDetails;
  count: number;
};

const MonitorLabel: React.FC<MonitorProps> = ({ showingReference }) => {
  const [connectedCount, setConnectedCount] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [connection, setConnection] = useState<signalR.HubConnection | null>(
    null
  );

  useEffect(() => {
    if (connection) {
      console.log('Connection already created');
      return;
    }
    console.log('Starting connection');
    const connectionX = new signalR.HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_API_URL}/notesHub`)
      .withAutomaticReconnect()
      .build();

    connectionX.on('UpdateGroupCount', (data: UpdateGroupCountModel) => {
      if (data.reference === showingReference) {
        setConnectedCount(data.count);
        setLoading(false);
      }
    });

    connectionX.on('RefreshCounts', () => {
      connectionX
        .invoke('RequestGroupCount', showingReference)
        .then(() =>
          console.log(
            `Message sent successfully: RequestGroupCount: ${showingReference}`
          )
        )
        .catch((err) => console.error('Error sending message: ', err));
    });

    connectionX
      .start()
      .then(() => {
        connectionX
          .invoke('RequestGroupCount', showingReference)
          .then(() =>
            console.log(
              `Message sent successfully: RequestGroupCount: ${showingReference}`
            )
          )
          .catch((err) => console.error('Error sending message: ', err));
        console.log('Connection established');
      })
      .catch((err) => console.error('Connection failed: ', err));

    connectionX.onreconnected(() => {
      console.log('Reconnected to the server');
      connectionX
        .invoke('RequestGroupCount', showingReference)
        .then(() =>
          console.log(
            `Message sent successfully: RequestGroupCount: ${showingReference}`
          )
        )
        .catch((err) => console.error('Error sending message: ', err));
      console.log('Connection established');
    });

    setConnection(connectionX);

    return () => {
      connectionX.off('UpdateGroupCount');
      connectionX.off('RefreshCounts');
      connectionX.stop();
    };
  }, []);

  if (loading) {
    return <></>;
  }

  if (connectedCount === 1) {
    return <>1 user connected</>;
  }

  return <>{connectedCount} users connected</>;
};

export default MonitorLabel;
